import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@material-ui/core';
import EditOutlined from '@material-ui/icons/EditOutlined';
import Search from '../../../components/Search/Search';
import DataTable from '../../../components/DataTable/DataTable';
import Filters from '../../../components/DataTable/Filters/Filters';
import CustomizeView from '../../../components/DataTable/CustomizeView/CustomizeView';
import PoolDialog from './PoolDialog';
import QueuePoolService from '../../../services/QueuePoolService/QueuePoolService';
import { personalizationState } from "../../../recoil-store/recoil-state";
import { useRecoilValue } from 'recoil';
import { convertToDateFormat } from '../../../helpers/helper';

/**
 * @Description This function returns Queue Pool page.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
const mock = [
    { pool_name: 'New Pool', description: 'This is a sample Pool', number_of_automs: 1, list: ['d0b0f84e-2a07-4f8d-b9bb-671899742e5f'] }
]
function QueuePool(props) {
    const label = 'CONTENT.QUEUE-POOL.';
    const personalization = useRecoilValue(personalizationState);
    const { t } = useTranslation();
    const [open, setOpen] = useState();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [searchData, setSearchData] = useState();
    const [customColumn, setCustomColumn] = useState([]);
    const [searchKeyData, setSearchKeyData] = useState('');
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const res = await QueuePoolService.getQueuePool();
        if (res?.status) {
            setData(res.data);
            setSearchData(res.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        const column = [{
            id: 0,
            name: '',
            label: '',
            options: { filter: false, sort: false }
        }, {
            id: 1,
            name: 'id',
            label: ' ',
            options: {
                filter: false, sort: false,
                customBodyRenderLite: (dataIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                }
            }
        }, {
            id: 2,
            name: 'pool_name',
            label: t(label + 'POOL-NAME'),
            options: { filter: true, sort: false }
        }, {
            id: 3,
            name: 'description',
            label: t(label + 'DESCRIPTION'),
            options: { filter: true, sort: false }
        }, {
            id: 4,
            name: 'number_of_automs',
            label: t(label + 'TOTAL-FLOWS'),
            options: {
                filter: true, sort: false,
                customBodyRenderLite: dataIndex => {
                    if (searchData && searchData[dataIndex]) {
                        return (<>
                            {searchData[dataIndex]?.number_of_automs}
                            <button onClick={() => setOpen({ type: 'view', id: searchData[dataIndex].id })} className="user-detail-link">
                                ({t(label + 'VIEW-ALL')})
                            </button>
                        </>);
                    }
                }
            }
        }, {
            id: 5,
            name: 'created_at',
            label: t(label + 'CREATED-ON'),
            options: {
                filter: true, sort: false,
                customBodyRenderLite: dataIndex => {
                    if (searchData && searchData[dataIndex]) {
                        return convertToDateFormat(searchData[dataIndex]?.created_at, personalization.date_format);
                    }
                }
            }
        }, {
            id: 6,
            name: 'updated_at',
            label: t(label + 'UPDATED-ON'),
            options: {
                filter: true, sort: false,
                customBodyRenderLite: dataIndex => {
                    if (searchData && searchData[dataIndex]) {
                        return convertToDateFormat(searchData[dataIndex]?.updated_at, personalization.date_format);
                    }
                }
            }
        }, {
            id: 7,
            name: 'actions',
            label: t(label + 'ACTIONS'),
            options: {
                filter: true, sort: false,
                customBodyRenderLite: dataIndex => {
                    if (searchData && searchData[dataIndex]) {
                        return (<>
                            <Button onClick={() => setOpen({ type: 'edit', id: searchData[dataIndex].id })} size="small">
                                <EditOutlined fontSize="small" color="disabled" style={{ margin: '0 5px 0 -20px' }} />
                                <span className="db-sublabel">{t(label + 'EDIT')}</span>
                            </Button>
                            <Button onClick={() => setOpen({ type: 'del', id: searchData[dataIndex].id })}>
                                <span className="db-sublabel">{t(label + 'DELETE')}</span>
                            </Button>
                        </>);
                    }
                }
            }
        }];
        setCustomColumn(column);
        setSearchKeyData(['pool_name', 'description', 'created_at', 'updated_at']);
    }, [searchData, setSearchKeyData]);

    return (
        <div id="credential-container">
            <Search data={data} setSearchData={setSearchData} searchKey={searchKeyData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button" onClick={() => setOpen({ type: 'add' })}>{t(label + 'ADD')}</Button>
                    <Button className="searchbar-button" onClick={() => setOpenCustomizeView(!openCustomizeView)}>
                        {t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}
                    </Button>
                    <Button className="searchbar-button" onClick={() => setOpenFilters(!openFilters)}>
                        {t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}
                    </Button>
                </Grid>
            </Search>
            <DataTable data={searchData} customColumns={customColumn} loading={loading} selectableRows="none" />
            {openCustomizeView &&
                <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn} setCustomColumn={setCustomColumn} />
            }
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />
            }
            {open && <PoolDialog open={open} setOpen={setOpen} fetchList={fetchData} />}
        </div>
    );
}

export default QueuePool;
